// extracted by mini-css-extract-plugin
export default {"title":"AddCoursesPopup_title__cwIEI","formItem":"AddCoursesPopup_formItem__sBn3c","actionWrap":"AddCoursesPopup_actionWrap__hrgpi"};